/**
 * API Configuration
 * Centralized API base URL configuration
 *
 * Environment variables are automatically loaded by Create React App:
 * - .env.development (for npm start)
 * - .env.production (for npm run build)
 *
 * Fallback to production URL if env var is not set
 */
// Prefer same-origin proxy (/api) to avoid CORS in both local + prod behind nginx.
// Can be overridden at build-time via REACT_APP_API_BASE_URL if needed.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";

export default API_BASE_URL;
